import React from 'react'

import Container from '@mui/material/Container'

import Loading from 'components/atoms/Loading'
import Typography from '@mui/material/Typography'
import Breadcrumbs from 'components/shared/Breadcrumbs'

import Form from 'components/account/PickupPeople/Form'

const NewPickupPerson = props => {
  const { mutationLoading, form } = props

  const buttonText = mutationLoading ? 'Creating...' : 'Create'

  return (
    <Container maxWidth='md'>
      <Breadcrumbs
        crumbs={[['Account Overview', '/'], ['Pick-up People'], ['New']]}
      />
      <Typography pb={4} variant='h2' align='center'>
        Add a Pickup Person
      </Typography>
      {!form ? <Loading /> : <Form buttonText={buttonText} {...props} />}
    </Container>
  )
}

export default NewPickupPerson
